import { CONFIG } from '@/constants';

export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  account: (state) => state.account,
  permissions: (state) => state.permissions,
  user: (state) => state.user,
  approvalKey: (state) => {
    if (!state.account) {
      return '';
    }
    return state.account.individual_master_data.approval_key;
  },
  hasIndividualWallet: (state) => {
    if (!state.account) {
      return false;
    }
    return !!state.account.individual_master_data.user_hw_wallet_address;
  },
  permittedRoutePaths: (state) => {
    return state.permissions
      .filter(
        (permission) => permission.method === CONFIG.PERMISSION_METHOD.VIEW,
      )
      .map((permission) => permission.path);
  },
};
